import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import DragDrop from 'components/atoms/CustomSVGIcon/DragDrop';

const DraggableCard = ({ text }) => {
	return (
		<Stack
			sx={{
				background: (theme) => theme.palette.background.paper,
				width: '316px',
				cursor: 'move',
				borderBottom: 'solid 1px rgba(187, 187, 187, 0.25)',
				padding: '10px 20px',
			}}
			direction="row"
		>
			<Box sx={{ color: 'info.shades.50p' }}>
				<DragDrop className="Sidebar-icon" />
			</Box>
			<Typography variant="body2" color="text.primary">
				{text}
			</Typography>
		</Stack>
	);
};

DraggableCard.propTypes = {
	text: PropTypes.string,
};

export default DraggableCard;
